import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LfInfoComponent',
  props: {
  message: {
    type: String as PropType<string>,
    required: true
  }
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})